import { z } from 'zod';
import { TDetailedErrorResponse } from 'src_server/trpc/types/error';

export const InputSchema = z.object({
    monthlyActivityReportLastConfirmedAt: z.string(),
});

export type ChangeMonthlyActivityReportModalType = z.infer<typeof InputSchema>;

export const SuccessResponseSchema = z.object({
    monthlyActivityReportLastConfirmedAt: z.string(),
});

export type ChangeMonthlyActivityReportModalResponseType = z.infer<typeof SuccessResponseSchema>;

export type TchangeMonthlyActivityReportModalType =
    | { responseStatus: 'success'; data: ChangeMonthlyActivityReportModalResponseType }
    | { responseStatus: 'error'; data: TDetailedErrorResponse };
